import { createContext } from 'react';

const CollapseContext = createContext<{
  idSet: Set<symbol>;
  add: (id: symbol) => void;
  remove: (id: symbol) => void;
}>({
  idSet: new Set(),
  add: () => {},
  remove: () => {},
});

export default CollapseContext;
